<template>
<div class="view view-error404">
    <top-bar v-if="isPortalReady" />

    <div class="anuncio-wrapper">
        <div class="d-flex">
            <div class="anuncio-image">
                <img :src="require('@/assets/images/sadface.png')" alt="">
            </div>
            <div class="d-flex align-items-center">
                <div>
                    <h3 class="anuncio-sobretitulo">Ha ocurrido un error</h3>
                    <h1 class="anuncio-titulo">404</h1>
                    <p>Lamentamos lo ocurrido, nada puede ser perfecto.<br>
                    Si tienes algun problema que reportar, por favor<br>
                    Escríbenos a <a class="color-aqua" href="mailto:soporte@topclass.cl">soporte@topclass.cl</a></p>
                    <p>
                        <router-link :to="{name: 'home'}"
                            class="btn btn-primary">
                            Continuar navegando
                        </router-link>
                    </p>
                </div>
            </div>
        </div>
    </div>




    <site-footer v-if="isPortalReady" />
</div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import TopBar from "../components/TopBar";
import SiteFooter from "../components/SiteFooter";

export default {
	name: "error404",
	components: {
		TopBar,
		SiteFooter
	},
	computed: {
		...mapState(["isPortalReady"])
	}
};
</script>
